var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('purchase-gallery-view',{attrs:{"items":_vm.purchasedItems,"total-items":_vm.totalItems,"item-id":_vm.itemId,"type":_vm.type,"loading":_vm.loading,"provider":_vm.provider,"enable-scroll":_vm.enableScroll},on:{"next":_vm.getNextPage}})}
var staticRenderFns = []

export { render, staticRenderFns }